import React from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteButton from '@/components/common/DeleteButton';
import Loader from '@/components/common/Loader';
import LoaderSizes from '@/constants/ui/LoaderSizes';
import translate from '@/lib/intl/translate';
import useFileItem, { type UseFileItemProps } from '../lib/useFileItem';

type FileItemProps = {
  multiple?: boolean;
} & UseFileItemProps;

function FileItem({
  context,
  file,
  fileName,
  id,
  multiple = false,
  onError,
  onRemove,
  onUpload,
  showDelete,
  uploadId,
}: FileItemProps) {
  const { handleDownload, handleRemove, isBusy } = useFileItem({
    context,
    file,
    fileName,
    id,
    onError,
    onRemove,
    onUpload,
    showDelete,
    uploadId,
  });

  return multiple ? (
    <li className="flex items-center">
      {uploadId ? (
        <>
          <button
            className="text-left text-tertiary-main"
            type="button"
            onClick={handleDownload}
          >
            {fileName}
          </button>
          {isBusy ? (
            <div className="ml-auto flex h-10 w-10 items-center justify-center">
              <Loader size={LoaderSizes.XS} />
            </div>
          ) : (
            showDelete && (
              <DeleteButton className="ml-auto" onClick={handleRemove} />
            )
          )}
        </>
      ) : (
        <>
          <span className="text-left">{fileName}</span>
          <div className="ml-auto flex h-10 w-10 items-center justify-center">
            <Loader size={LoaderSizes.XS} />
          </div>
        </>
      )}
    </li>
  ) : (
    <div className="flex flex-col items-center">
      <CloudUploadIcon className="mb-6 text-3xl" />
      {uploadId ? (
        <>
          <button
            className="mb-2 text-tertiary-main"
            type="button"
            onClick={handleDownload}
          >
            {fileName}
          </button>
          {isBusy ? (
            <Loader size={LoaderSizes.XS} />
          ) : (
            showDelete && (
              <button
                className="text-error-main type-body3"
                type="button"
                onClick={handleRemove}
              >
                {translate('REMOVE_FILE')}
              </button>
            )
          )}
        </>
      ) : (
        <>
          <span className="mb-2">{fileName}</span>
          <Loader size={LoaderSizes.XS} />
        </>
      )}
    </div>
  );
}

export default FileItem;
